import styles from './index.module.scss';

import classNames from 'classnames';
import ArrowLeftSvg from 'components/svg/ArrowLeftSvg';
import ArrowRightSvg from 'components/svg/ArrowRightSvg';
import { useAppContext } from 'context/state';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { AppTheme } from 'types/enums';
import Button from '../Button';
import P from '../P';
import { useRouter } from 'next/navigation';
// import { usePathname, useRouter } from 'i18n/navigation';

interface Props {
  title: string | React.JSX.Element;
  emoji?: React.JSX.Element;
  className?: string;
  itemClassName?: string;
  onBackClick?: () => void;
  showButton?: boolean;
  link?: string;
  onAllWatchClick?: () => void;
  rightButton?: React.JSX.Element;
}

/**
 * @title string|React.JSX.Element
 * @emoji React.JSX.Element
 * @className string
 * @onBackClick ()=>void
 * @showButton boolean
 * @link string
 * @rightButton ?: React.JSX.Element
 * @onAllWatchClick ?: ()=>void
 */
export default function Title(props: Props) {
  const appContext = useAppContext();
  const isLightTheme = appContext.theme === AppTheme.Light;
  const { isTabletWidth } = appContext.size;
  const router = useRouter();
  // const pathname = usePathname();
  const t = useTranslations();

  // const handleBackClick = () => {
  //   if (props.onBackClick) {
  //     const selectedLanguage = Cookies.get(CookiesType.locale);
  //     if (selectedLanguage) {
  //       Cookies.remove(CookiesType.locale);
  //       Cookies.set(CookiesType.locale, selectedLanguage, { path: '/' });
  //       Cookies.set(CookiesType.isChangedLang, JSON.stringify(true));
  //       router.refresh();
  //       // router.replace(pathname, { locale: selectedLanguage });
  //     }
  //     props.onBackClick();
  //   }
  // };

  return (
    <div className={classNames(styles.root, props.className)}>
      {((isTabletWidth && props.onBackClick) || props.showButton) && (
        <Button
          styleType={['icon', 'black']}
          altStyleType={['icon', 'white', 'invertSvg']}
          className={classNames(styles.backButton, props.itemClassName)}
          // onClick={handleBackClick}
        >
          <ArrowLeftSvg />
        </Button>
      )}
      <P styleType={['huge', 'w600']} style={{ marginLeft: '-1px' }} useThemeColor>
        {props.title}
      </P>
      {props.emoji}
      {((isTabletWidth && props.onBackClick) || props.showButton) && !props.rightButton && (
        <div className={styles.filler}></div>
      )}{' '}
      {isTabletWidth && props.link && (
        <Link className={classNames(styles.link, props.itemClassName)} href={props.link}>
          {t('all')} <ArrowRightSvg color={isLightTheme && 'black'} />
        </Link>
      )}
      {isTabletWidth && props.onAllWatchClick && (
        <div
          className={classNames(styles.link, props.itemClassName)}
          onClick={props.onAllWatchClick}>
          <P useThemeColor>{t('all')}</P> <ArrowRightSvg color={isLightTheme && 'black'} />
        </div>
      )}
      {props.rightButton}
    </div>
  );
}
